/** @jsxImportSource @emotion/react */
import colors from '@sportninja/common/constants/appColors'

interface QuestionTypeIconProps {
  size?: number
  color?: string
  className?: string
}

/**
 * UrlIcon component - Icon for URL question type
 * @param size - Icon size in pixels (default: 24)
 * @param color - Icon color (default: colors.NEUTRAL_50)
 * @param className - Additional CSS class name
 */
const UrlIcon = ({
  size = 24,
  color = colors.NEUTRAL_50,
  className,
}: QuestionTypeIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 25'
      fill='none'
      className={className}
    >
      <path
        d='M17 7.5H14C13.45 7.5 13 7.95 13 8.5C13 9.05 13.45 9.5 14 9.5H17C18.65 9.5 20 10.85 20 12.5C20 14.15 18.65 15.5 17 15.5H14C13.45 15.5 13 15.95 13 16.5C13 17.05 13.45 17.5 14 17.5H17C19.76 17.5 22 15.26 22 12.5C22 9.74 19.76 7.5 17 7.5ZM8 12.5C8 13.05 8.45 13.5 9 13.5H15C15.55 13.5 16 13.05 16 12.5C16 11.95 15.55 11.5 15 11.5H9C8.45 11.5 8 11.95 8 12.5ZM10 15.5H7C5.35 15.5 4 14.15 4 12.5C4 10.85 5.35 9.5 7 9.5H10C10.55 9.5 11 9.05 11 8.5C11 7.95 10.55 7.5 10 7.5H7C4.24 7.5 2 9.74 2 12.5C2 15.26 4.24 17.5 7 17.5H10C10.55 17.5 11 17.05 11 16.5C11 15.95 10.55 15.5 10 15.5Z'
        fill={color}
      />
    </svg>
  )
}

export default UrlIcon
